import restUtils from "@/restUtils";
import constants from '@/constants';
import utils from '@/utils';

const path = '/sweph';

const emptyState = {
    swephData: null,

    /**
     * Подсвечивать на короткое время некорректные введённые данные для полей ввода Натала
     */
    natalFormError: false,

    /**
     * Время и место рождения
     */
    natal: {
        inputDate: null,
        inputTime: null,
        inputCity: null
    },
    /**
     * Текущее время и текущее местонахождение
     */
    transit: {
        inputDate: null,
        inputTime: null,
        inputCity: null
    },

    dynamic: {
        natal: 0,
        transit: 0,
        direction: 0,
        progression: 0,
        multimap: 0
    },

    additionalMapMode: null,
    lastPickedAdditionalMapMode: null
};

export default {
    namespace: true,
    state: Object.assign({}, emptyState),

    actions: {
        async loadSwephData({commit, state}, payload) {
            if (!utils.validateNatalInputData(state.natal.inputDate, state.natal.inputTime, state.natal.inputCity)) {
                if (!payload || !payload.silent) {
                    // Подсвечиваем поля ввода на 1.5 секунды красным
                    commit('setNatalFormError', true);
                    setTimeout(() => {
                        commit('setNatalFormError', false);
                    }, 1500);
                }

                return false;
            }

            let birthDate = utils.concatDateAndTime(state.natal.inputDate, state.natal.inputTime);

            let data = {
                birthDate: birthDate,
                birthLat: state.natal.inputCity.lat,
                birthLng: state.natal.inputCity.lng,

                natalDynamic: state.dynamic.natal
            };

            if (state.additionalMapMode === constants.mode.multimap) {
                Object.assign(data, {
                    transitDynamic: state.dynamic.multimap,
                    directionDynamic: state.dynamic.multimap,
                    progressionDynamic: state.dynamic.multimap
                });
            } else {
                Object.assign(data, {
                    transitDynamic: state.dynamic.transit,
                    directionDynamic: state.dynamic.direction,
                    progressionDynamic: state.dynamic.progression
                });
            }

            if (utils.validateNatalInputDateTime(state.transit.inputDate, state.transit.inputTime)) {
                let transitDate = utils.concatDateAndTime(state.transit.inputDate, state.transit.inputTime);
                Object.assign(data, {
                    currentDate: transitDate
                });
            }

            if (utils.validateNatalInputCity(state.transit.inputCity)) {
                Object.assign(data, {
                    currentLat: state.transit.inputCity.lat,
                    currentLng: state.transit.inputCity.lng
                });
            }

            let success;
            try {
                const swephData = await restUtils.doPost(path, data);
                commit('loadSwephData', swephData);
                success = true;
            } catch (error) {
                success = false;
                alert(error.response.data.message);
            }

            return success;
        },

        clearSweph({commit}) {
            commit('clearState');
        },

        async changeDynamic({commit, getters, dispatch}, payload) {
            if (!payload.shift || payload.shift == 0)
                return;

            let dynamic;
            switch (payload.mode) {
                case constants.mode.transit:
                    dynamic = getters.transitDynamic;
                    break;
                case constants.mode.direction:
                    dynamic = getters.directionDynamic;
                    break;
                case constants.mode.progression:
                    dynamic = getters.progressionDynamic;
                    break;
                case constants.mode.multimap:
                    dynamic = getters.multimapDynamic;
                    break;
                default:
                    dynamic = getters.natalDynamic;
            }

            dynamic += (payload.shift || 0);
            switch (payload.mode) {
                case constants.mode.transit:
                    commit('setTransitDynamic', dynamic);
                    break;
                case constants.mode.direction:
                    commit('setDirectionDynamic', dynamic);
                    break;
                case constants.mode.progression:
                    commit('setProgressionDynamic', dynamic);
                    break;
                case constants.mode.multimap:
                    commit('setMultimapDynamic', dynamic);
                    break;
                default:
                    commit('setNatalDynamic', dynamic);
            }

            await dispatch('loadSwephData');
        },

        changeAdditionalMapMode({state, commit, dispatch}, payload) {
            let prevMode = state.additionalMapMode || state.lastPickedAdditionalMapMode;
            let newMode = payload;

            let additionalModes = [constants.mode.transit, constants.mode.direction, constants.mode.progression];
            let modeChangedToOrFromMultimap = (additionalModes.includes(prevMode) && newMode === constants.mode.multimap)
                    || (additionalModes.includes(newMode) && prevMode === constants.mode.multimap);

            commit('setAdditionalMapMode', newMode);

            // Если поменяли режим доп.карты на Мультикарту или с Мультикарты,
            // и если хотя бы одна динамика доп.карт не равна нулю,
            // то во избежание расхождения отображаемых данных Транзита/Дирекции/Прогрессии в разных режимах
            // повторно выполняем расчёт позиций планет
            if (modeChangedToOrFromMultimap
                    && (state.dynamic.transit != 0 || state.dynamic.direction != 0
                            || state.dynamic.progression != 0 || state.dynamic.multimap != 0)) {
                dispatch('loadSwephData', {
                    silent: true
                });
            }
        }
    },

    mutations: {
        loadSwephData: (state, payload) => state.swephData = payload,

        setNatalFormError: (state, payload) => state.natalFormError = payload,

        setInputDate: (state, payload) => {
            state.natal.inputDate = payload;
            // Обнуляем динамику при измненении даты
            state.dynamic.natal = 0;
        },
        setInputTime: (state, payload) => {
            state.natal.inputTime = payload;
            state.dynamic.natal = 0;
        },
        setInputCity: (state, payload) => state.natal.inputCity = payload,

        setTransitInputDate: (state, payload) => {
            state.transit.inputDate = payload;
            // Обнуляем динамику при измненении даты
            state.dynamic.transit = 0;
            state.dynamic.direction = 0;
            state.dynamic.progression = 0;
            state.dynamic.multimap = 0;
        },
        setTransitInputTime: (state, payload) => {
            state.transit.inputTime = payload;
            state.dynamic.transit = 0;
            state.dynamic.direction = 0;
            state.dynamic.progression = 0;
            state.dynamic.multimap = 0;
        },
        setTransitInputCity: (state, payload) => state.transit.inputCity = payload,

        setNatalDynamic: (state, payload) => state.dynamic.natal = payload,
        setTransitDynamic: (state, payload) => state.dynamic.transit = payload,
        setDirectionDynamic: (state, payload) => state.dynamic.direction = payload,
        setProgressionDynamic: (state, payload) => state.dynamic.progression = payload,
        setMultimapDynamic: (state, payload) => state.dynamic.multimap = payload,

        setAdditionalMapMode: (state, payload) => {
            state.additionalMapMode = payload;
            if (!!payload)
                state.lastPickedAdditionalMapMode = payload;
        },

        clearState: (state) => Object.assign(state, emptyState)
    },

    getters: {
        swephData: (state) => state.swephData,

        natalFormError: (state) => state.natalFormError,

        inputDate: (state) => state.natal.inputDate,
        inputTime: (state) => state.natal.inputTime,
        inputCity: (state) => state.natal.inputCity,

        transitInputDate: (state) => state.transit.inputDate,
        transitInputTime: (state) => state.transit.inputTime,
        transitInputCity: (state) => state.transit.inputCity,

        natalDynamic: (state) => state.dynamic.natal,
        transitDynamic: (state) => state.dynamic.transit,
        directionDynamic: (state) => state.dynamic.direction,
        progressionDynamic: (state) => state.dynamic.progression,
        multimapDynamic: (state) => state.dynamic.multimap,

        additionalMapMode: (state) => state.additionalMapMode
    }
};